import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Auto-uppercase utility function
export function handleUppercaseInput(e) {
  const input = e.target;
  const excludedTypes = ['email', 'tel', 'search', 'password', 'url', 'number'];
  const excludedClasses = ['no-uppercase'];

  // Check if this input should be excluded from auto-capitalization
  if (excludedTypes.includes(input.type) ||
      excludedClasses.some(cls => input.classList.contains(cls))) {
    return;
  }

  const upper = input.value.toUpperCase();
  if (upper === input.value) {
    return; // Already uppercase — nothing to do, and avoids needless events
  }

  const cursorPosition = input.selectionStart;

  // IMPORTANT: Setting `input.value` directly updates React's internal value
  // tracker, which makes React believe the value did not change and SUPPRESSES
  // the controlled input's onChange — silently breaking edits on every text
  // <input> (textarea/number are unaffected). To avoid this, set the value
  // through the native prototype setter so React's tracker is left untouched and
  // React's own onChange still fires with the new (uppercased) value.
  const proto = Object.getPrototypeOf(input);
  const nativeSetter = proto && Object.getOwnPropertyDescriptor(proto, 'value')?.set;
  if (nativeSetter) {
    nativeSetter.call(input, upper);
  } else {
    input.value = upper;
  }
  input.setSelectionRange(cursorPosition, cursorPosition);
}

// Apply auto-uppercase to all eligible inputs on page load
export function initializeAutoUppercase() {
  const inputs = document.querySelectorAll('input[type="text"]:not(.no-uppercase), input:not([type]):not(.no-uppercase)');
  
  inputs.forEach(input => {
    // Skip if already has event listener
    if (input.hasAttribute('data-uppercase-initialized')) return;
    
    input.addEventListener('input', handleUppercaseInput);
    input.setAttribute('data-uppercase-initialized', 'true');
  });
}
